var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Guid } from '@gower/utils';
import React from 'react';
import { HookSetup } from '../store';
import Event from 'typescript.events';
var ObjectHook = /** @class */ (function (_super) {
    __extends(ObjectHook, _super);
    function ObjectHook(object) {
        var _this = _super.call(this) || this;
        _this.current = null;
        _this.current = HookSetup(function (keyChanged, newValue, oldValue) { return _this.emit('changed', { keyChanged: keyChanged, newValue: newValue, oldValue: oldValue }); }, object);
        return _this;
    }
    ObjectHook.prototype.destroy = function () {
        this.removeAllListeners(['changed']);
    };
    return ObjectHook;
}(Event));
export function useObject(object) {
    var wrapper = React.useState(new ObjectHook(object))[0];
    var _a = React.useState(null), _uid = _a[0], set__uid = _a[1];
    function handler(status) {
        set__uid(Guid(1));
    }
    React.useEffect(function () {
        wrapper.addListener('changed', function (a) { return handler(a); });
        return function () { wrapper.destroy(); };
    }, []);
    return wrapper.current;
}
;
